//@ts-ignore
const getImageCsCart = (main_pair: any, size = 'large'): string => {
  /* const w = maxWidth ? `w=${maxWidth}` : ''
  const h = maxHeight ? `h=${maxHeight}` : ''*/

  const returnImgPath = image => {
    if (image) {
      // URL S3 presignee (backend storage pharmes3) : ne JAMAIS la reecrire — la regle
      // de repli ci-dessous remplacerait le segment bucket par le host CloudFront et
      // casserait la signature. Elle est deja complete et valide telle quelle.
      if (image.includes('X-Amz-Signature') || image.includes('.io.cloud.ovh.net/')) {
        return image
      }
      if (image && image.includes('localhost:3008')) {
        return (
          image.replace('localhost:3008', 'd1ihszsyl0wr5t.cloudfront.net') ?? '/images/no-image.png'
        )
      }
      return (
        image.replace(/\/[^/]+\/images\//, '/d1ihszsyl0wr5t.cloudfront.net/images/') ??
        '/images/no-image.png'
      )
    } else {
      return '/images/no-image.png'
    }
  }

  if (main_pair?.detailed?.image_path) {
    return returnImgPath(main_pair?.detailed?.image_path)
  } else if (main_pair?.icon?.image_path) {
    return returnImgPath(main_pair?.icon?.image_path)
  } else if (size == 'large' && !main_pair?.icons?.iconSmall.image_path) {
    return returnImgPath(main_pair?.detailed?.image_path)
  } else {
    return returnImgPath(main_pair?.icons?.iconSmall.image_path)
  }
}
export { getImageCsCart }
